import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetUserByIdData } from "../../../lib/data";
import i18n from "../../../lib/i18n";
import EditUsersUi from "../../../ui/usersUi/editUsersUi.jsx";

export default function EditUsers() {

    const { userId } = useParams();
    const [userData, setUserData] = useState({});
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const usersData = await GetUserByIdData(userId);
        setUserData(usersData);
    };

    return (
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("edit_page_title.user")}</h1>
                <EditUsersUi userData={userData} />
            </div>
        </div>
    );
};